import * as ProjectConfig from 'Models/utils/project-config';
import algoliasearch from 'algoliasearch';
import fetchData from 'Models/fetch-data';

export function setActiveBreakpoints (store) {
    const breakpoints = store.getters.getBreakpoints;
    const activeBreakpoints = [];
    const windowWidth = store.getters.getWindowWidth;
    for (const breakpoint of breakpoints) {
        if (breakpoint.width <= windowWidth) {
            activeBreakpoints.push(breakpoint.id);
        } else {
            break;
        }
    }

    store.commit('setActiveBreakpoints', activeBreakpoints);
}

export function setHeaderHeight (store) {
    const headerHeightSwitchBreakpoint = 'tablet-landscape';

    const headerHeights = {
        small: 60,
        big: 80,
    };

    const headerHeightVersion = store.getters.getActiveBreakpoints.indexOf(headerHeightSwitchBreakpoint) >= 0 ? 'big' : 'small';
    const newHeaderHeight = headerHeights[headerHeightVersion];

    if (store.getters.getHeaderHeight === newHeaderHeight) {
        return false;
    }
    store.commit('setHeaderHeight', newHeaderHeight);
}

export function setWindowHeight (store) {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    store.commit('setWindowHeight', window.innerHeight);
}

export function search (store, { query, showSuggestions = true }) {
    const searchClient = store.state.searchClient;
    query = query.trim();

    if (query === store.state.searchQuery) {
        return;
    }

    store.commit('setSearchQuery', query);
    store.commit('setActiveSearchCategoryTab', 'all');

    if (searchClient === 'factfinder') {
        store.commit('setSearchSuggestionsActive', true);
        store.commit('setSearchSuggestionsLoading', true);
        searchSuggestions(store, query, showSuggestions);
        store.commit('setSearchLoading', true);
        searchCmsResults(store, query);
    } else {
        store.commit('setSearchLoading', true);
        searchAlgolia(store, query);
    }
}

async function searchSuggestions (store, query, showSuggestions = true) {
    let searchUrl = ProjectConfig.get('factfinder.suggestionsApiUrl');
    searchUrl = searchUrl.replace('QUERY', query);
    if (query === '') {
        store.commit('setSearchSuggestionsCurrentlyVisible', false);
        return;
    }
    try {
        const response = await fetchData(searchUrl, 'GET');
        if (response.success) {
            for (const key in response) {
                if (key !== 'success') {
                    store.commit('setSearchSuggestions', {
                        key: key,
                        results: response[key],
                    });
                }
            }
            store.commit('setSearchSuggestionsLoading', false);
            if (showSuggestions) store.commit('setSearchSuggestionsCurrentlyVisible', true);
        } else {
            store.commit('setSearchSuggestions', {});
            store.commit('setSearchSuggestionsLoading', false);
            store.commit('setSearchSuggestionsCurrentlyVisible', false);
        }
    } catch (error) {
        console.error(error);
        store.commit('setSearchSuggestionsCurrentlyVisible', false);
    }
}

async function searchCmsResults (store, query) {
    const indices = ProjectConfig.get('factfinder.indices');
    let searchUrl = ProjectConfig.get('factfinder.cmsSearchApiUrl');
    searchUrl = searchUrl.replace('QUERY', query);
    indices.forEach(index => {
        searchUrl += `&indexNames[]=${index.indexKey}`;
    });
    try {
        const response = await fetchData(searchUrl, 'GET');
        if (response.results) {
            // set results
            for (let i = 0; i < indices.length; i++) {
                store.commit('setSearchResults', {
                    key: indices[i].key,
                    results: response.results[i].hits,
                });
            }
            store.commit('setSearchLoading', false);
        }
    } catch (error) {
        console.error(error);
    }
}

function searchAlgolia (store, query) {
    let algoliaSearchClient;
    const indices = ProjectConfig.get('algolia.indices');
    const queries = [];

    indices.forEach(index => {
        queries.push({
            indexName: index.indexKey,
            query: query,
        });
    });

    if (!algoliaSearchClient && ProjectConfig.get('algolia.id') && ProjectConfig.get('algolia.key')) {
        algoliaSearchClient = algoliasearch(
            ProjectConfig.get('algolia.id'),
            ProjectConfig.get('algolia.key'),
        );
    }

    if (!algoliaSearchClient) {
        console.error('Cant initialize algolia search client. Configuration is missing');
        return;
    }

    algoliaSearchClient.search(queries, function (err, response) {
        if (err !== null) {
            console.log(err);
        }

        // set results
        for (let i = 0; i < indices.length; i++) {
            store.commit('setSearchResults', {
                key: indices[i].key,
                results: response.results[i].hits,
            });
        }
        store.commit('setSearchLoading', false);
    });
}
